import "./SecondPart.css";
import InsideOfSecondPart from "../insideOfParts/InsideOfSecondPart";
import guyWithPhoneLight from "../../assets/images/guyWithPhoneLight.png";
import guyWithPhoneDark from "../../assets/images/guyWithPhoneDark.png";
import React, { useState } from "react";
import useLocalStorageState from "use-local-storage-state";

function SecondPart({
  setPhase,
  phase,
  videosWatchedSecondWeek,
  videoPhaseSecondWeek,
  setVideoPhaseSecondWeek,
  videosWatchedFirstWeek,
  seen1,
  seen2,
  seen3,
  seen4,
  timestamps,
  today,
  setShowDialog,
  setDialogContent,
  allContent,
}) {
  const image1 = `url(${guyWithPhoneLight})`;
  const image2 = `url(${guyWithPhoneDark})`;
  let backgroundImage;
  const [collectStickerSecond, setCollectStickerSecond] = useState(0);
  const [sticker2Claimed, setSticker2Claimed] = useLocalStorageState(
    "sticker2Claimed",
    false
  );

  switch (true) {
    case today < timestamps[1]:
      backgroundImage = null;
      break;
    case phase === 1 && today > timestamps[1]:
    case phase === 2.5 && today > timestamps[1]:
    case phase === 3 && today > timestamps[1]:
    case phase === 3.5 && today > timestamps[1]:
    case phase === 4 && today > timestamps[1]:
    case phase === 4.5 && today > timestamps[1]:
    case phase === 5 && today > timestamps[1]:
    case phase === 5.5 && today > timestamps[1]:
    case phase === 6 && today > timestamps[1]:
      backgroundImage = image2;
      break;
    default:
      backgroundImage = null;
      break;
  }

  return (
    <div
      className={(() => {
        switch (phase) {
          case 1:
          case 2.5:
          case 3.5:
          case 4.5:
          case 5.5:
            return "secondContainer width333";
          case 3:
            return "secondContainer width1090 weekAnimation";
          default:
            return "secondContainer width80";
        }
      })()}
    >
      <div
        style={{ backgroundImage }}
        className="secondContainerContent shadowLeft"
      >
        <div
          onClick={() => {
            setPhase(3);
          }}
          className={(() => {
            switch (true) {
              case seen3 && seen4:
                return "weekText yellowWeek";
              case today > timestamps[1]:
                return "weekText purpleWeek";
              default:
                return "weekText grayWeek";
            }
          })()}
        >
          <p>2</p>
          <p>{allContent.week}</p>
        </div>
        <div
          className={(() => {
            switch (true) {
              case phase === 1 && today > timestamps[1]:
              case phase === 3 && today > timestamps[1]:
              case phase === 3 && today < timestamps[1]:
                return "displayNone";
              case phase === 0 || today > timestamps[1]:
                return "episodeText";
              default:
                return "episodeText";
            }
          })()}
        >
          {allContent.week2.episode}
        </div>
        <InsideOfSecondPart
          setPhase={setPhase}
          phase={phase}
          videosWatchedSecondWeek={videosWatchedSecondWeek}
          videoPhaseSecondWeek={videoPhaseSecondWeek}
          setVideoPhaseSecondWeek={setVideoPhaseSecondWeek}
          videosWatchedFirstWeek={videosWatchedFirstWeek}
          seen1={seen1}
          seen2={seen2}
          seen3={seen3}
          seen4={seen4}
          timestamps={timestamps}
          today={today}
          setShowDialog={setShowDialog}
          setDialogContent={setDialogContent}
          allContent={allContent}
        />
        <div
          className={(() => {
            switch (true) {
              case phase === 0 || today < timestamps[1]:
              case phase === 2 || today < timestamps[1]:
                return "displayNone";
              default:
                return "lineHolderDown";
            }
          })()}
        ></div>
        <div
          className={(() => {
            switch (phase) {
              case 0:
              case 1:
              case 2:
              case 2.5:
              case 3.5:
              case 4.5:
              case 5.5:
                return "stickerHolder";
              case 3:
                return "stickerHolderRight";
              default:
                return "displayNone";
            }
          })()}
        >
          <p className={phase === 3 ? "moreGoodies" : "displayNone"}>
            {allContent.watchVideo.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
          <button
            id="RAM_BTN_Week2_StickerClaim"
            disabled={seen3 && seen4 ? false : true}
            onClick={() => {
              setCollectStickerSecond(1);
              setSticker2Claimed(true);
            }}
            className={(() => {
              switch (true) {
                case sticker2Claimed && phase === 3:
                  return "claimedSticker";
                case phase === 3 && seen3 && seen4:
                  return "buttonCollectSticker";
                case phase === 3:
                  return "grayButtonApp";
                default:
                  return "displayNone";
              }
            })()}
          >
            {sticker2Claimed
              ? allContent.buttonCollectSticker.button2
              : allContent.buttonCollectSticker.button1}
          </button>
          <img
            className="stickerImage secondStickerImage"
            src={allContent.week2.sticker}
            alt="sticker"
          />
          <p
            className={(() => {
              switch (true) {
                case phase === 1 && today > timestamps[1]:
                  return "";
                case phase === 1 && today < timestamps[1]:
                  return "grayFontsInactive";
                case phase === 0 ||
                  phase === 2 ||
                  phase === 3 ||
                  phase === 4 ||
                  phase === 5 ||
                  phase === 6:
                  return "displayNone";
                default:
                  return "";
              }
            })()}
          >
            {allContent.collectableSticker.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
        <div
          className={(() => {
            switch (true) {
              case today > timestamps[1]:
                return "displayNone";
              case today < timestamps[1]:
                return "lightOverlay";
              default:
                return "displayNone";
            }
          })()}
        ></div>
        {/* STICKER NOTIFICATION HOLDER */}
        <div
          className={(() => {
            switch (true) {
              case collectStickerSecond === 0:
                return "displayNone";
              case videosWatchedSecondWeek === 2:
              case collectStickerSecond === 1:
                return "notificationSticker";
              default:
                return "displayNone";
            }
          })()}
        >
          <div className="notificationStickerHolder">
            <div className="stickersClaimed">
              <img
                src={allContent.week2.multipleSticker}
                alt="stickersCoverWeek"
              />
            </div>
            <h2>
              {allContent.collectWindow.titles.title2
                .split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </h2>
            <p>
              {allContent.collectWindow.description
                .split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </p>
            <button
              onClick={() => {
                setCollectStickerSecond(0);
                setPhase(1);
              }}
              className="mainButtonApp buttonWidth"
            >
              {allContent.collectWindow.button}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecondPart;
